<template>
  <b-modal
        scrollable
    id="is-order-pending-modal"
    ref="modal"
    header-class="headerModal"
    centered
    size="s"
    :title="`${clickedOrder}: ${clickedHouseAll}`"
    hide-footer
    @hide="onCancel"
  >
    <LoadingWrapperSpinner
      request-id="loadIsOrderInTransit"
      :response-data="getIsOrderInTransit"
      style="border:transparent !important;"
    >
      <span
        v-if="!getIsOrderInTransit"
        style="color: #262E6C; font-weight: 500;"
      > {{ $t('AreYouSureOrder') }} </span>
    </LoadingWrapperSpinner>
    <span
      v-if="getIsOrderInTransit"
      style="color: #262E6C; font-weight: bold;"
    >
      {{ $t('AlreadyInTransit') }}
    </span>
    <div class="buttonsEverywhere">
      <button
        type="button"
        variant="none"
        style="margin-left: 0px;"
        class="buttonSubmit"
        :disabled="getIsOrderInTransit"
        @click="onSubmit"
      >
      <div
          v-if="loading"
          style="width:100%"
          class="pdf-spinner-overlay"
        >
          <span class="loader" />
        </div>
        {{ $t('Submit') }}
      </button>
      <b-button
        type="reset"
        variant="danger"
        class="buttonCancel"
        style="margin-right: 15px; background: white; color: black; border-color: white;font-weight: 400;"
        @click="onCancel"
      >
        {{ $t('Cancel') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'


export default {
  props: ['clickedOrder', 'clickedOrderItemId', 'clickedHouseAll', 'storeId'],
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapGetters([
      'getIsOrderInTransit',
      'getLoadingStates',
    ]),
    isOrderInTransitLoading() {
      return this.getLoadingStates.loadIsOrderInTransit;
    },
  },
  methods: {
    ...mapActions([
      'loadAddWindowInPending',
      'resetIsOrderInTransit',
      'loadIsOrderInTransit',
      'resetDetailsOrderId',
    ]),
    async onSubmit() {
      try {
        this.loading = true
        await this.loadAddWindowInPending({
          windowItemId: this.clickedOrderItemId,
          storeId: this.storeId,
          successCallback: () => {
            this.loading = false
            this.$refs.modal.hide();
            this.onReset();
            this.resetDetailsOrderId()
            this.$emit('updateOrderItemPending');
          },
        });
      } catch (error) {
        this.loading = false
      }
    },
    onCancel() {
      this.onReset();
    },
    onReset() {
      this.resetIsOrderInTransit()
      this.$refs.modal.hide();
    },
  },
}
</script>

  <style lang="scss" scoped>
  .display-articles{
  display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 5px;
  }

  </style>
